<template>
    <!-- a thin strip hanging under the search, opened to narrow the catalogue to the risks we can screen for the
         picked screenings -->
    <div :class="['catalogue-filter', { open }]">
        <button class="catalogue-filter-toggle" :aria-expanded="open" aria-controls="catalogue-filter-options"
            @click="open = !open"
        >
            <span>{{ $t("catalogue.filter.label") }}</span>
            <!-- what is picked stays readable with the strip closed -->
            <span class="catalogue-filter-picked">
                <template v-if="selected.length">
                    <catalogue-audience v-for="audience in audiences.filter(audience => selected.includes(audience))"
                        :key="audience" :audience="audience" :title="$t('catalogue.audience.' + audience)"
                    />
                </template>
                <template v-else>{{ $t("catalogue.filter.all") }}</template>
            </span>
            <svg class="catalogue-filter-caret" viewBox="0 0 24 24" width="16" height="16" fill="none"
                stroke="currentColor" stroke-width="2.5"
            >
                <path d="M6 9l6 6 6-6"></path>
            </svg>
        </button>
        <div v-show="open" id="catalogue-filter-options" class="catalogue-filter-options">
            <label v-for="audience in audiences" :key="audience" class="catalogue-filter-option">
                <input type="checkbox" :checked="selected.includes(audience)" @change="$emit('toggle', audience)">
                <catalogue-audience :audience="audience" />
                <span>{{ $t("catalogue.audience." + audience) }}</span>
                <span class="catalogue-filter-count">{{ counts[audience] }}</span>
            </label>
        </div>
    </div>
</template>

<script>
import CatalogueAudience from "./CatalogueAudience.vue";

export default {
    components: { CatalogueAudience },
    props: {
        audiences: { type: Array, required: true },
        selected: { type: Array, required: true },
        counts: { type: Object, required: true }
    },
    emits: ["toggle"],
    data: function () {
        return {
            open: false
        };
    }
};
</script>
